import { render, staticRenderFns } from "./json.formatter.modal.vue?vue&type=template&id=3c4b30f4&scoped=true&"
import script from "./json.formatter.modal.vue?vue&type=script&lang=js&"
export * from "./json.formatter.modal.vue?vue&type=script&lang=js&"
import style0 from "./json.formatter.modal.vue?vue&type=style&index=0&id=3c4b30f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b30f4",
  null
  
)

export default component.exports